import Vue from 'vue'
import Router from 'vue-router'
import { getOpenScreenInformation, getLearnReportOpenScreenInformation } from "@/api/zhixue";
import { getYunPanConfigInfo, activeYunWrongPaperBook, activeTelecomYunWrongPaperBook } from "@/api/extra";
import { getInfo } from "@/api/user";
import store from "@/store";
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
const originalPush = Router.prototype.push

//解决报错信息：NavigationDuplicated: Avoided redundant navigation to current location
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/test',
      name: 'test',
      meta: {
        title: '测试'
      },
      component: () => import('@/views/test')
    },
    {
      path: '/',
      name: '',
      meta: { title: '首页' },
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/home/index')
    },
    {
      path: '/homexiaoyi',
      name: 'homexiaoyi',
      meta: {
        title: '首页'
      },
      component: () => import('@/views/home/index'),
      beforeEnter: (to, from, next) => {
        

      },
    },
    {
      path: '/homeZhixue',
      name: 'homeZhixue',
      meta: { title: '首页' },
      component: () => import('@/views/home/index_zhixue')
    },
    {
      path: '/bindPhone',
      name: 'bindPhone',
      meta: { title: '绑定手机号' },
      component: () => import('@/views/bindPhone')
    },
    {
      path: '/bindTransfer',
      name: 'bindTransfer',
      meta: { title: '绑定设备' },
      component: () => import("@/views/bind/bindTransfer")
    },
    {
      path: '/bind',
      name: 'bind',
      meta: { title: '填写设备信息', keepAlive: true },
      component: () => import("@/views/bind/index")
    },
    {
      path: '/autoBind',
      name: 'autoBind',
      meta: { title: '自动绑定' },
      component: () => import("@/views/bind/autoBind")
    },
    {
      path: '/guideAudit',
      name: 'guideAudit',
      meta: { title: '引导审核' },
      component: () => import("@/views/bind/guideAudit")
    },
    {
      path: '/login',
      name: 'login',
      meta: { title: '登录' },
      component: () => import('@/views/login')
    },
    {
      path: '/editContacts',
      name: 'editContacts',
      meta: { title: '编辑联系人' },
      component: () => import('@/views/contacts/editContacts')
    },
    {
      path: '/phoneBook',
      name: 'phoneBook',
      meta: { title: '电话本' },
      component: () => import('@/views/contacts/index')
    },
    {
      path: '/waitBind',
      name: 'waitBind',
      meta: { title: '设备信息' },
      component: () => import('@/views/bind/waitBind')
    },
    {
      path: '/call',
      name: 'call',
      meta: { title: '通话' },
      component: () => import('@/views/call/index')
    },
    {
      path: '/ban',
      name: 'ban',
      meta: { title: '上课禁用' },
      component: () => import('@/views/ban/index')
    },
    {
      path: '/setTime',
      name: 'setTime',
      meta: { title: '选择时间' },
      component: () => import('@/views/ban/setTime')
    },
    {
      path: '/family',
      name: 'family',
      meta: { title: '家庭成员' },
      component: () => import('@/views/bind/family')
    },
    {
      path: '/search',
      name: 'search',
      meta: { title: '找设备' },
      component: () => import('@/views/search/index')
    },
    {
      path: '/equipmentInfo',
      name: 'equipmentInfo',
      meta: { title: '用户信息' },
      component: () => import('@/views/bind/equipmentInfo')
    },
    {
      path: '/editEquipmentInfo',
      name: 'editEquipmentInfo',
      meta: { title: '编辑资料', keepAlive: true },
      component: () => import('@/views/bind/editEquipmentInfo')
    },
    {
      path: '/map',
      name: 'map',
      meta: { title: '地图' },
      component: () => import('@/views/map/index')
    },
    {
      path: '/fileView',
      name: 'fileView',
      meta: { title: '文件预览' },
      component: () => import('@/views/common/fileView')
    },
    {
      path: '/choiceFamily',
      name: 'choiceFamily',
      meta: { title: '关系选择' },
      props: true,
      component: () => import('@/views/bind/choiceFamily')
    },
    {
      path: '/HistoryOfSpacecraftDevelopment',
      name: 'HistoryOfSpacecraftDevelopment',
      meta: { title: '世界载人航天器发展史' },
      props: true,
      component: () => import('@/views/banner/HistoryOfSpacecraftDevelopment')
    },
    {
      path: '/history',
      name: 'history',
      meta: { title: '扫描记录' },
      component: () => import('@/views/history/index')
    },
    {
      path: '/history/detail',
      name: 'historyDetail',
      meta: { title: '扫描记录' },
      component: () => import('@/views/history/detail')
    },
    {
      path: '/history/search',
      name: 'historySearch',
      meta: { title: '扫描记录搜索' },
      component: () => import('@/views/history/search')
    },
    {
      path: '/history/upload',
      name: 'historyUpload',
      meta: { title: '扫描记录上传' },
      component: () => import('@/views/history/upload')
    },
    {
      path: '/equipmentSwitch',
      name: 'equipmentSwitch',
      meta: { title: '通话禁用' },
      component: () => import('@/views/equipmentSwitch/index')
    },
    {
      path: '/unicomLogin',
      name: 'unicomLogin',
      meta: { title: '登录联通网盘' },
      component: () => import('@/views/unicom/login')
    },
    {
      path: '/bindLtPan',
      name: 'bindLtPan',
      meta: { title: '绑定联通网盘' },
      component: () => import('@/views/unicom/bindLtPan')
    },
    {
      path: '/bindYunPan',
      name: 'bindYunPan',
      meta: { title: '绑定移动云盘' },
      component: () => import('@/views/yunpan/bindYunPan')
    },
    {
      path: '/bindTelecomYunPan',
      name: 'bindTelecomYunPan',
      meta: { title: '绑定天翼云盘' },
      component: () => import('@/views/telecomYunpan/bindTelecomYunPan')
    },
    {
      path: '/linkToLtPan',
      name: 'linkToLtPan',
      meta: { title: '联通网盘小程序' },
      component: () => import('@/views/unicom/ltpan-link')
    },
    {
      path: '/yunpan/setting',
      name: 'yunpanSetting',
      meta: { title: '云盘设置' },
      component: () => import('@/views/yunpan/setting')
    },
    {
      path: '/yunpan/wrongPaperBook/before',
      name: 'wrongPaperBookBefore',
      meta: { title: '云错题本' },
      component: () => import('@/views/yunpan/wrongPaperBook/before')
    },
    {
      path: '/yunpan/wrongPaperBook/index',
      name: 'wrongPaperBook',
      meta: { title: '云错题本' },
      component: () => import('@/views/yunpan/wrongPaperBook/index'),
      beforeEnter: (to, from, next) => {
        //判断是否开启
        // getYunPanConfigInfo().then(res => {
        //   var data = res.data;
        //   var autoSaveWrongCheck = data.autoSaveWrongCheck;
        //   if (autoSaveWrongCheck == 0) {
        //     next({
        //       path: '/yunpan/wrongPaperBook/before',
        //       replace: false
        //     })
        //   } else {
        //     next();
        //   }
        // })

        activeYunWrongPaperBook().then(res => {
          next();
        })
      }
    },

    {
      path: '/telecomYunpan/setting',
      name: 'telecomYunpanSetting',
      meta: { title: '云盘设置' },
      component: () => import('@/views/telecomYunpan/setting')
    },
    {
      path: '/telecomYunpan/wrongPaperBook/before',
      name: 'telecomYunpanWrongPaperBookBefore',
      meta: { title: '云错题本' },
      component: () => import('@/views/telecomYunpan/wrongPaperBook/before')
    },
    {
      path: '/telecomYunpan/wrongPaperBook/index',
      name: 'telecomYunpanWrongPaperBook',
      meta: { title: '云错题本' },
      component: () => import('@/views/telecomYunpan/wrongPaperBook/index'),
      beforeEnter: (to, from, next) => {
        //判断是否开启
        // getYunPanConfigInfo().then(res => {
        //   var data = res.data;
        //   var autoSaveWrongCheck = data.autoSaveWrongCheck;
        //   if (autoSaveWrongCheck == 0) {
        //     next({
        //       path: '/yunpan/wrongPaperBook/before',
        //       replace: false
        //     })
        //   } else {
        //     next();
        //   }
        // })
        activeTelecomYunWrongPaperBook().then(res => {
          next();
        })
      }
    },
    {
      path: '/watch/index',
      name: 'watchIndex',
      meta: { title: '云盘' },
      component: () => import('@/views/watch/index'),
    },
    {
      path: '/watch/error',
      name: 'watchError',
      meta: { title: '提示' },
      component: () => import('@/views/watch/error'),
    },
    {
      path: '/watch/cmcc/setting',
      name: 'watchCmccSetting',
      meta: { title: '云盘设置' },
      component: () => import('@/views/watch/cmcc/setting'),
    },
    {
      path: '/watch/cmcc/before',
      name: 'watchCmccBefore',
      meta: { title: '云盘' },
      component: () => import('@/views/watch/cmcc/before')
    },
    {
      path: '/watch/telecom/before',
      name: 'watchTelecomBefore',
      meta: { title: '云盘' },
      component: () => import('@/views/watch/telecom/before')
    },
    {
      path: '/sms/login',
      name: 'smsLogin',
      meta: { title: '手机号登录' },
      component: () => import('@/views/sms/login')
    },
    {
      path: '/sms/free',
      name: 'smsFree',
      meta: { title: '免费领' },
      component: () => import('@/views/sms/free')
    },
    {
      path: '/sms/smsOpen',
      name: 'smsOpen',
      meta: { title: '开通短信推送' },
      component: () => import('@/views/sms/sms-open')
    },
    {
      path: '/watch/telecom/setting',
      name: 'watchTelecomSetting',
      meta: { title: '云盘设置' },
      component: () => import('@/views/watch/telecom/setting'),
    },
    {
      path: '/smartLearn',
      name: 'smartLearn',
      meta: { title: '智学' },
      // redirect: '/smartLearn/slideLearn',
      component: () => import('@/views/smartLearn/index'),
      children: [
        {
          path: 'paperLearn',
          name: 'paperLearn',
          meta: { title: '智学做题', keepAlive: true },
          component: () => import('@/views/smartLearn/paperLearn/paperLearn'),
          beforeEnter: (to, from, next) => {
            console.log('fullPath:' + to.fullPath)
            var query = to.query;
            var isOpenScreen = query.isOpenScreen;
            var isNo = query.isNo;
            var isSms = query.isSms;
            var paperCode = query.paperCode;
            if (isOpenScreen && isOpenScreen === 'isOpenScreen') {
              // getOpenScreenInformation({ paperCode: paperCode }).then(res => {
              //   if (res.data) {
              //     next({
              //       path: '/smartLearnOther/openScreen',
              //       query: {
              //         paperCode: paperCode,
              //       },
              //       replace: false
              //     })
              //   } else {
              //     next();
              //   }
              // })
              next({
                path: '/smartLearnOther/openScreen',
                query: {
                  paperCode: paperCode,
                  isNo: isNo,
                  isSms: isSms
                },
                replace: false
              })

            } else {
              next();
            }
          },
        },
        {
          path: 'learnHistory',
          name: 'learnHistory',
          meta: { title: '智学历史', yunTitle: '智学记忆' },
          component: () => import('@/views/smartLearn/learnHistory/learnHistory'),
        },
      ]
    },
    {
      path: '/smartLearnOther',
      name: 'smartLearnOther',
      meta: { title: '智学' },
      // redirect: '/smartLearn/slideLearn',
      component: () => import('@/views/smartLearn/indexOther'),
      children: [
        {
          path: 'slideLearn',
          name: 'slideLearn',
          meta: { title: '智学' },
          component: () => import('@/views/smartLearn/slideLearn/slideLearn'),
        },
        {
          path: 'openScreen',
          name: 'openScreen',
          meta: { title: '智学做题' },
          component: () => import('@/views/smartLearn/paperLearn/openScreen'),
        },
        {
          path: 'tips',
          name: 'tips',
          meta: { title: '智学提示' },
          component: () => import('@/views/smartLearn/paperLearn/tips'),
        },
        {
          path: 'final',
          name: 'final',
          meta: { title: '智学结果页' },
          component: () => import('@/views/smartLearn/paperLearn/final'),
        },
        {
          path: 'guide',
          name: 'guide',
          meta: { title: '智学开通引导' },
          component: () => import('@/views/smartLearn/openLearn/guide'),
        },
        {
          path: 'openPay',
          name: 'openPay',
          meta: { title: '智学开通' },
          component: () => import('@/views/smartLearn/openLearn/openPay'),
        },
        {
          path: 'learnIndex',
          name: 'learnIndex',
          meta: { title: '智学' },
          component: () => import('@/views/smartLearn/learnIndex'),
        },
        {
          path: 'shareRank',
          name: 'shareRank',
          meta: { title: '智学分享' },
          component: () => import('@/views/smartLearn/shareRank'),
        },
        {
          path: 'learnReport',
          name: 'learnReport',
          meta: { title: '我的词库' },
          component: () => import('@/views/smartLearn/learnReport'),
          beforeEnter: (to, from, next) => {
            var imei = store.getters.cpr.penNo;
            var query = to.query;
            var isOpenScreen = query.isOpenScreen;
            if (isOpenScreen && isOpenScreen === 'isOpenScreen') {
              getLearnReportOpenScreenInformation({ imei: imei }).then(res => {
                if (res.data) {
                  next({
                    path: '/smartLearnOther/openScreenReport',
                  })
                } else {
                  next();
                }
              }).catch((err) => {
                next(false)
              })

            } else {
              next();
            }
          },
        },
        {
          path: 'reportTips',
          name: 'reportTips',
          meta: { title: '我的词库提示' },
          component: () => import('@/views/smartLearn/reportTips'),
        },
        {
          path: 'openScreenReport',
          name: 'openScreenReport',
          meta: { title: '我的词库' },
          component: () => import('@/views/smartLearn/openScreenReport'),
        },
      ]
    },
    {
      path: '/reward/learnReward',
      name: 'learnReward',
      meta: { title: '我的金豆' },
      component: () => import('@/views/reward/learnReward')
    },
    {
      path: '/reward/pick',
      name: 'pick',
      meta: { title: '申请提现' },
      component: () => import('@/views/reward/pick')
    },
    {
      path: '/reward/account/flowDetail',
      name: 'flowDetail',
      meta: { title: '流水明细' },
      component: () => import('@/views/reward/account/flow_detail')
    },
    {
      path: '/reward/account/pick',
      name: 'accountPick',
      meta: { title: '提现' },
      component: () => import('@/views/reward/account/pick')
    },
    {
      path: '/active',
      name: 'acitve',
      meta: { title: '活动' },
      component: () => import('@/views/active/index'),
      children: [
        {
          path: 'share',
          name: 'share',
          meta: { title: '分享有礼' },
          component: () => import('@/views/active/share/index'),
          children: [
            {
              path: 'rechargeCoupon',
              name: 'rechargeCoupon',
              meta: { title: '领取优惠券' },
              component: () => import('@/views/active/share/rechargeCoupon')
            },
            {
              path: 'rechargeCouponByElevator',
              name: 'rechargeCouponByElevator',
              meta: { title: '领取优惠券' },
              component: () => import('@/views/active/share/rechargeCouponByElevator')
            },
            {
              path: 'introduce',
              name: 'introduce',
              meta: { title: '分享活动介绍' },
              component: () => import('@/views/active/share/introduce')
            },
            {
              path: 'poster',
              name: 'poster',
              meta: { title: '活动海报' },
              component: () => import('@/views/active/share/poster'),
              beforeEnter: (to, from, next) => {
                getInfo().then(res => {
                  if (res.data.isBindPhone != 1) {
                    next('/active/share/introduce')
                  } else {
                    next();
                  }
                }).catch((err) => {
                  next(false)
                })
              },
            }
          ]
        }
      ]
    },
    // {
    //   path: '/shop',
    //   name: 'shop',
    //   meta: { title: '云非凡官方商城' },
    //   component: () => import('@/views/shop/index'),
    //   children: [
    //     {
    //       path: 'home',
    //       name: 'shopHome',
    //       meta: { title: '云非凡官方商城' },
    //       component: () => import('@/views/shop/home/index'),
    //       children: [
    //         {
    //           path: 'mine',
    //           name: 'shopMine',
    //           meta: { title: '云非凡官方商城' },
    //           component: () => import('@/views/shop/home/mine'),
    //         },
    //         {
    //           path: 'list',
    //           name: 'shopList',
    //           meta: { title: '云非凡官方商城' },
    //           component: () => import('@/views/shop/home/list'),
    //         },
    //       ]
    //     },
    //     {
    //       path: 'goldHome',
    //       name: 'goldShopHome',
    //       meta: { title: '云非凡金豆商城' },
    //       component: () => import('@/views/shop/goldHome/index'),
    //       children: [
    //         {
    //           path: 'mine',
    //           name: 'goldShopMine',
    //           meta: { title: '云非凡金豆商城' },
    //           component: () => import('@/views/shop/goldHome/mine'),
    //         },
    //         {
    //           path: 'list',
    //           name: 'GoldShopList',
    //           meta: { title: '云非凡金豆商城' },
    //           component: () => import('@/views/shop/goldHome/list'),
    //         },
    //         {
    //           path: 'listTest',
    //           name: 'goldShopListTest',
    //           meta: { title: '云非凡金豆商城' },
    //           component: () => import('@/views/shop/goldHome/list_test'),
    //         },
    //       ]
    //     },
    //     {
    //       path: 'item/detail',
    //       name: 'itemDetail',
    //       meta: { title: '商品详情' },
    //       component: () => import('@/views/shop/item/detail'),
    //     },
    //     {
    //       path: 'address/edit',
    //       name: 'editAddress',
    //       meta: { title: '编辑收货地址' },
    //       component: () => import('@/views/shop/address/edit_address'),
    //     },
    //     {
    //       path: 'address/list',
    //       name: 'addressList',
    //       meta: { title: '我的收货地址' },
    //       component: () => import('@/views/shop/address/address_list'),
    //     },
    //     {
    //       path: 'address/choice',
    //       name: 'choiceAddress',
    //       meta: { title: '我的收货地址' },
    //       component: () => import('@/views/shop/address/choice_address'),
    //     },
    //     {
    //       path: 'order/submitOrder',
    //       name: 'submitOrder',
    //       meta: { title: '提交订单', keepAlive: true },
    //       component: () => import('@/views/shop/order/submitOrder'),
    //     },
    //     {
    //       path: 'order/myOrder',
    //       name: 'myOrder',
    //       meta: { title: '我的订单' },
    //       component: () => import('@/views/shop/order/my_order'),
    //     }
    //   ]
    // },
    {
      path: '/orderPackage/index',
      name: 'packageIndex',
      meta: { title: '套餐首页' },
      component: () => import('@/views/orderPackage/index'),
    },
    {
      path: '/orderPackage/authentication',
      name: 'authentication',
      meta: { title: '卡片实名' },
      component: () => import('@/views/orderPackage/authentication'),
    },
    {
      path: '/orderPackage/orderPackage',
      name: 'orderPackage',
      meta: { title: '订购套餐' },
      component: () => import('@/views/orderPackage/order-package'),
    },
    {
      path: '/orderPackage/addCard',
      name: 'addCard',
      meta: { title: '新增卡片' },
      component: () => import('@/views/orderPackage/add-card'),
    },
    {
      path: '/orderPackage/addCarefully',
      name: 'addCarefully',
      meta: { title: '家庭成员' },
      component: () => import('@/views/orderPackage/add-carefully'),
    },
    {
      path: '/orderPackage/bill',
      name: 'bill',
      meta: { title: '账单中心' },
      component: () => import('@/views/orderPackage/bill'),
    },
    {
      path: '/bluetooth/index',
      name: 'bluetoothIndex',
      meta: { title: '连接蓝牙' },
      component: () => import('@/views/bluetooth/index'),
    }

  ],
  scrollBehavior: () => ({ y: 0 })
})



// WEBPACK FOOTER //
// ./src/router/index.js